import {SmartComponent} from "smart-component-js";

class FormDeceasedDateComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    init() {
        document.addEventListener('yxp-form-loaded', () => {
            const DateOfBirth = document.querySelector('form input[name="DateOfBirth"]');
            const DateOfDeath = document.querySelector('form input[name="DateOfDeath"]');
            const DateOfBirthApplicant = document.querySelector('form input[name="DateOfBirthApplicant"]');
            youserxp.utils.dateFillHelper(DateOfBirth, 'DD/MM/YYYY');
            youserxp.utils.dateFillHelper(DateOfDeath, 'DD/MM/YYYY');
            youserxp.utils.dateFillHelper(DateOfBirthApplicant, 'DD/MM/YYYY');

        })

        document.addEventListener('yxp-form-submit-ok', () => {
            const privacyDisclaimer = document.querySelector('.privacy-disclaimer')
            if (privacyDisclaimer) {
                privacyDisclaimer.classList.add('hidden')
            }
        })
    }
}

export default FormDeceasedDateComponent;